exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".font-size-16 {\n  font-size: 16px; }\n\n.image-height-50 {\n  height: 50px; }\n\n.atm-codes-location {\n  font-size: 16px;\n  margin-bottom: 2px; }\n\n.atm-edit-height {\n  position: absolute;\n  right: 10px;\n  height: 20px; }\n\n.text-align-right {\n  text-align: right; }\n\n.atm-code-box {\n  width: 100px !important;\n  text-align: center; }\n\n.display-inline-block {\n  display: inline-block; }\n\n.margin-top-05 {\n  margin-top: 5px; }\n\n.msg-font-size {\n  font-size: 15px; }\n\n.atm-code-info-section {\n  display: flex;\n  justify-content: space-between;\n  gap: 5px; }\n\n.atm-codes-date-picker-section .datetimepicker-wrapper {\n  display: block !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/atm_codes_management/atm_codes_management.scss
// module id = 952
// module chunks = 1